import { render, staticRenderFns } from "./UserEditTabSocial.vue?vue&type=template&id=eeec5d8c"
import script from "./UserEditTabSocial.vue?vue&type=script&lang=js"
export * from "./UserEditTabSocial.vue?vue&type=script&lang=js"
import style0 from "./UserEditTabSocial.vue?vue&type=style&index=0&id=eeec5d8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports